import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  @Input() text: string;
  @Input() picture: string;
  @Input() button: { label: string; action: () => void };

  constructor(private popoverController: PopoverController) {}

  ngOnInit() {}

  handleClick() {
    if (this.button.action) {
      this.button.action();
      this.popoverController.dismiss();
    }
  }
}
